import React, { useState, useEffect, useRef } from 'react';
import { useFetch } from '../../utils/hooks/useFetch';
import { AllPostsApi } from '../../api/base/AllPosts';
import { BaseTypography } from 'src/components/common';
import { useCommonStyles } from '../../materialConfig/commonStyles';
import { makeStyles } from '@material-ui/core/styles';
import { AllPostsCard } from './AllPostsCard';
import { BlogPostsCard } from './BlogPostsCard';
import { Grid, styled } from '@material-ui/core';
import { BaseButton, BaseCard } from '../../components/common';


import Checkbox from "@material-ui/core/Checkbox";
import InputLabel from '@material-ui/core/InputLabel';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Select from '@material-ui/core/Select';
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from '@material-ui/core/FormControl';
import ListItemText from "@material-ui/core/ListItemText";
import { useLocation, useHistory } from 'react-router-dom'
import "./AllPosts.css";

const useStyles = makeStyles((theme) => ({
	root: {
		padding: '50px 20px'
	},
	buttonContainer: {
		display: 'flex',
		flexWrap: 'wrap',
		boxSizing: 'border-box',
		margin: '-4px',
		position: 'relative'
	},
	buttonPrimary: {
		color: '#000',
		cursor: "pointer",
		border: '1px solid #0090E5',
		boxShadow: 'unset',
		boxSizing: 'border-box',
		backgroundColor: 'rgba(218, 239, 251, 0.3)',
		padding: '11px 16px',
		fontSize: '16px',
		margin: '0 4px',
		position: 'relative',
		'&.active': {
			background: '#0090E5',
			color: '#FFF',
		},
		'&.removeitems': {
			display: 'none'
		}
	},
	formControl: {
		border: '0',
		background: '#FFF',
		boxShadow: '0',
		color: '#FFF',
		width: '150px',
		padding: '0',
		textAlign: 'left',
		backgroundColor: 'rgba(218, 239, 251, 0.3)',
	},
	tabbtn: {
		background: '#FFF',
		color: '#AAAAAA',
		fontSize: '25px',
		fontWeight: '600',
		borderBottom: '2px solid #EEEEEE !important',
		borderTop: '0 !important',
		borderLeft: '0 !important',
		borderRight: '0 !important',
		padding: '25px 0',
		height: 'auto',
		'&.active': {
			borderBottom: '2px solid #0073C9 !important',
			borderTop: '0 !important',
			borderLeft: '0 !important',
			borderRight: '0 !important',
			color: '#000000',
			background: 'none !important',
		},
		'&:focus': {
			borderBottom: '2px solid #0073C9 !important',
			borderTop: '0 !important',
			borderLeft: '0 !important',
			borderRight: '0 !important',
			color: '#000000',
			background: 'none !important',
			boxShadow: 'none !important',
		},
		'&:hover': {
			borderBottom: '2px solid #0073C9 !important',
			borderTop: '0 !important',
			borderLeft: '0 !important',
			borderRight: '0 !important',
			color: '#000000',
			background: 'none !important',
			boxShadow: 'none !important',
		},
		'@media (max-width:768px)': {
			padding: '20px 0',
		},
	}
}));


export const AllPosts: React.FC = () => {
	const searchParams: any = new URLSearchParams(useLocation().search);
	const commonClasses = useCommonStyles();
	const classes = useStyles();
	const [{ response }, doFetch] = useFetch(AllPostsApi.getAllPosts);

	useEffect(() => {
		if (searchParams.get('id')) {
			doFetch(searchParams.get('id'));
		} else {
			doFetch(0);
		}
	}, [doFetch]);

	const [{ response: test }, doFetch1] = useFetch(AllPostsApi.getBlogPosts);
	useEffect(() => {
		doFetch1();
	}, [doFetch1]);

	/* const url = "https://dev.api.contactsbook.media/api/v1/blogposts";
	const [data, setData] = useState([]);
  
	const fetchInfo = () => {
	  return fetch(url)
		.then((res) => res.json())
		.then((d) => setData(d))
	}
  
  
	useEffect(() => {
	  fetchInfo();
	}, []); */

	const [List, setlist] = useState([]);

	const data_arr: any[] = response?.data.data;

	const blogpost_arr: any[] = test?.data.data;

	const [buttonList, setButtonList] = useState([
		{
			id: "315",
			name: "Information Technology",
			active: false
		},
		{
			id: "539",
			name: "Sustainability",
			active: false
		},
		{
			id: "251",
			name: "Finance",
			active: false
		},
		{
			id: "53",
			name: "Banking",
			active: false
		},
		{
			id: "43",
			name: "Artificial Intelligence",
			active: false
		},
		{
			id: "334",
			name: "Investment Banking",
			active: false
		},
		{
			id: "443",
			name: "Portfolio Management",
			active: false
		},
	]);

	const addtoList = (expertId: any) => {
		const test_arr: any[] = [];
		for (let i = 0; i < data_arr.length; i += 1) {
			const exp_arr = data_arr[i].expertise;
			const found = exp_arr.includes(expertId);
			if (found) {
				test_arr.push(data_arr[i]);
			}
		}
		const final = List.filter((el: any) => {
			return !test_arr.find((element: any) => {
				return element.id === el.id;
			});
		});
		setlist(final);
	}

	const removeList = (expertId: any) => {
		for (let i = 0; i < data_arr.length; i += 1) {
			const exp_arr: any = data_arr[i].expertise;
			const found: any = exp_arr.includes(expertId);
			if (found) {
				setlist((prev: any[]) => ([...prev, data_arr[i]]));
			}
		}
	}

	const mouseClick = (e: any, btn: any, index: any) => {
		e.preventDefault();
		if (btn.active) {
			addtoList(btn.id);
		} else {
			removeList(btn.id);
		}
		setButtonList((prev: any) =>
		([
			...prev.filter((x: any) => {
				if (x.id === btn.id) {
					x.active = !x.active;
				}
				return x;
			}
			)])
		);

	}

	const names: any[] = [
		// {
		// 	id: "315",
		// 	name: "Information Technology"
		// },
		// {
		// 	id: "539",
		// 	name: "Sustainability"
		// },
		// {
		// 	id: "251",
		// 	name: "Finance"
		// }
	];

	const [personName, setPersonName] = useState([{ id: "zero", name: "All" }]);
	const [getExpert, setGetExpert] = useState([]);

	const [selectnames, setSelectnames] = useState([
		{
			id: "228",
			name: "Energy",
			active: false
		},
		{
			id: "229",
			name: "Engineering",
			active: false
		},
		{
			id: "182",
			name: "Cryptocurrency",
			active: false
		},
		{
			id: "61",
			name: "Blockchain",
			active: false
		},
		{
			id: "363",
			name: "Machine Learning",
			active: false
		},
		{
			id: "464",
			name: "Project Management",
			active: false
		},
		{
			id: "646",
			name: "WEB3",
			active: false
		},
		{
			id: "470",
			name: "Public Policy",
			active: false
		},
		{
			id: "371",
			name: "Marketing",
			active: false
		},
		{
			id: "471",
			name: "Public Relation",
			active: false
		},
		{
			id: "48",
			name: "Audit",
			active: false
		},
		{
			id: "305",
			name: "Human Resources",
			active: false
		},
	]);

	const history = useHistory();

	const handleChange = (event: any) => {
		const { target: { value }, } = event;
		const allfound = value.includes('All');
		console.log(value);

		if (allfound) {
			history.push("/allposts");
			window.location.reload();
		} else {
			if (value[0]?.name === "All") {
				value.shift();
				removeList(value[0].id)
			}
			else if (getExpert.length) {
				if (value.length > getExpert.length) {
					const SingleExpert = value.filter((el: any) => {
						return !getExpert.find((element: any) => {
							return element === el;
						});
					});
					removeList(SingleExpert[0].id);
				} else if (value.length < getExpert.length) {
					const SingleExpert: any = getExpert.filter((el: any) => {
						return !value.find((element: any) => {
							return element === el;
						});
					});
					addtoList(SingleExpert[0].id);
				}
			} else if (value.length && value !== 'undefined') {
				removeList(value[0].id)
			} else {
				removeList(getExpert[0].id)
			}
			setGetExpert(value);
			setPersonName(value);
		}
	};

	const ref: any = useRef<HTMLDivElement>(null);

	const removebuttons = () => {
		if (ref.current.offsetHeight > 50) {
			const childnodes = ref.current.childNodes;
			for (let i = 0; i < childnodes.length; i += 1) {
				if (childnodes[i].offsetTop > 0) {
					childnodes[i].classList.add('removeitems');
					const exp_id = childnodes[i].getAttribute("data-id");
					const exp_text = childnodes[i].innerText;
					// names.push({ id:exp_id, name:exp_text });
					setSelectnames((prev: any[]) => (
						[...prev, { id: exp_id, name: exp_text }]
					));
				}
			}
		}
	}

	useEffect(() => {
		const handleResize = () => {
			window.location.reload();
		}
		window.addEventListener('resize', handleResize);
		removebuttons();
	}, []);

	useEffect(() => {
		if (response?.data.data.length && searchParams.get('id')) {
			removeList(searchParams.get('id'));
			const checkList: any = buttonList?.filter((x: any) => x.id === searchParams.get('id'));
			if (checkList.length) {
				setButtonList((prev: any) => ([
					...prev.filter((x: any) => {
						if (x.id === searchParams.get('id')) {
							x.active = !x.active;
						}
						return x;
					}
					)]));
			} else {
				const getExpertise: any[] = Object.entries(response?.data.expertise).filter((x: any) => x[1]?.id === parseFloat(searchParams.get("id")));

				const addObj: any = {
					id: `${getExpertise[0][1]?.id}`,
					name: getExpertise[0][1]?.name,
					active: true
				}

				setButtonList(([addObj].concat(buttonList)));
			}
		}
	}, [response]);

	useEffect(() => {
		removebuttons();
	}, [buttonList]);

	const [isShowstorieshub, setIsShowstorieshub] = useState<boolean>(false);
	const [isShowblogpost, setIsShowblogpost] = useState<boolean>(false);

	const storieshubElement = (
		<div >
			<BaseTypography variant="h4" style={{ marginBottom: '20px' }}>Select a topic to view suggested experts</BaseTypography>
			<div style={{ marginBottom: '30px' }}>
				<div ref={ref} className={classes.buttonContainer}>
					<FormControl className={classes.formControl}>
						<InputLabel id="demo-multiple-name-label">Select</InputLabel>
						<Select
							labelId="demo-multiple-name-label"
							id="demo-multiple-name"
							multiple
							value={personName}
							onChange={handleChange}
							input={<OutlinedInput label="Select" />}
							renderValue={(selected: any) => selected.map((x: any) => x.name).join(', ')}
						>
							<MenuItem value='All'>
								<ListItemText primary="All" />
							</MenuItem>
							{selectnames.map((name) => (
								<MenuItem
									key={name.id}
									value={name}
								>
									<Checkbox checked={personName.indexOf(name) > -1} />
									<ListItemText primary={name.name} />
								</MenuItem>
							))}


						</Select>
					</FormControl>
					{
						buttonList?.map((btn: any, index: any) => (
							<button
								key={btn.id}
								className={`${classes.buttonPrimary} ${btn.active ? 'active' : ""}`}
								type="button"
								data-id={btn.id}
								onClick={(e: any) => mouseClick(e, btn, index)}
							>
								{btn.name}
							</button>
						))
					}
				</div>
			</div>
			{searchParams.get('id') ? <AllPostsCard response={List.length ? List : ''} /> : <AllPostsCard response={List.length ? List : data_arr} />}
		</div>
	);

	const blogpostElement = (
		<div>
			<BlogPostsCard response1={blogpost_arr} />
		</div>
	);

	useEffect(() => {
		if (searchParams.get('tab') === 'blogposts') {
			setIsShowblogpost(true);
			history.push('/allposts?tab=blogposts');
		} else {
			setIsShowstorieshub(true);
			history.push('/allposts?tab=storyposts');
		}
	}, []);

	return (
		<div className="app" style={{ background: '#fff' }}>
			<div className={`${commonClasses.container} ${classes.root}`}>
				<div className="filter-container">
					<>
						<Grid container spacing={0}>
							<Grid item xs={12} md={3}>
								<BaseButton className={`${classes.tabbtn} ${isShowstorieshub === true && 'active'}`} id="story_button"
									fullWidth
									onClick={() => {
										setIsShowstorieshub(true);
										setIsShowblogpost(false);
										history.push('/allposts?tab=storyposts');
									}}>
									Stories hub
								</BaseButton>
							</Grid>
							<Grid item xs={12} md={3}>
								<BaseButton className={`${classes.tabbtn} ${isShowblogpost === true && 'active'}`} fullWidth onClick={() => {
									setIsShowblogpost(true);
									setIsShowstorieshub(false);
									history.push('/allposts?tab=blogposts');
								}}>
									Blog post
								</BaseButton>
							</Grid>
						</Grid>
					</>
					<div style={{ marginTop: '50px' }}>
						{isShowstorieshub && storieshubElement}
						{isShowblogpost && blogpostElement}
					</div>
					<div style={{ marginBottom: '30px' }}>
						<div ref={ref} className={classes.buttonContainer}>
							<FormControl className={classes.formControl} style={{ display: 'none' }}>
								<InputLabel id="demo-multiple-name-label">Select</InputLabel>
								<Select
									labelId="demo-multiple-name-label"
									id="demo-multiple-name"
									multiple
									value={personName}
									onChange={handleChange}
									input={<OutlinedInput label="Select" />}
									renderValue={(selected: any) => selected.map((x: any) => x.name).join(', ')}
								>
									{selectnames.map((name) => (
										<MenuItem
											key={name.id}
											value={name}
										>
											<Checkbox checked={personName.indexOf(name) > -1} />
											<ListItemText primary={name.name} />
										</MenuItem>
									))}

									<MenuItem value='All'>
										<ListItemText primary="All" />
									</MenuItem>
								</Select>
							</FormControl>

						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
